/**
 * 主应用组件 - 路由和布局
 */

import { useState } from 'react';
import HomePage from './pages/HomePage';
import ReportPage from './pages/ReportPage';
import ChildrenPage from './pages/ChildrenPage';
import DNAPage from './pages/DNAPage';

type TabType = 'home' | 'report' | 'children' | 'dna';

export default function App() {
  const [activeTab, setActiveTab] = useState<TabType>('home');
  const [showMore, setShowMore] = useState(false);

  // 渲染页面
  const renderPage = () => {
    switch (activeTab) {
      case 'home':
        return <HomePage />;
      case 'report':
        return <ReportPage />;
      case 'children':
        return <ChildrenPage />;
      case 'dna':
        return <DNAPage />;
      default:
        return <HomePage />;
    }
  };

  // 导航项（底部主导航）
  const navItems: { id: TabType; label: string; icon: string }[] = [
    { id: 'home', label: '求助', icon: '🆘' },
    { id: 'report', label: '上报', icon: '📝' },
    { id: 'children', label: '宝贝', icon: '👶' },
    { id: 'dna', label: 'DNA', icon: '🔬' },
  ];

  return (
    <div className="min-h-screen bg-bg-dark flex flex-col max-w-lg mx-auto relative">
      {/* 页面内容 */}
      <div className="flex-1 overflow-auto pb-20">
        {renderPage()}
      </div>

      {/* 底部导航 */}
      <nav className="fixed bottom-0 left-0 right-0 max-w-lg mx-auto bg-bg-light/95 backdrop-blur-sm border-t border-white/10 safe-area-bottom z-50">
        <div className="flex">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => {
                setActiveTab(item.id);
                setShowMore(false);
              }}
              className={`
                flex-1 py-3 flex flex-col items-center gap-1
                transition-colors no-highlight
                ${activeTab === item.id ? 'text-sos-red' : 'text-text-muted'}
              `}
            >
              <span className="text-2xl">{item.icon}</span>
              <span className="text-xs">{item.label}</span>
            </button>
          ))}

          {/* 更多按钮 */}
          <button
            onClick={() => setShowMore(!showMore)}
            className={`
              flex-1 py-3 flex flex-col items-center gap-1
              transition-colors no-highlight
              ${showMore ? 'text-sos-red' : 'text-text-muted'}
            `}
          >
            <span className="text-2xl">☰</span>
            <span className="text-xs">更多</span>
          </button>
        </div>
      </nav>

      {/* 更多菜单 */}
      {showMore && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setShowMore(false)}
        >
          <div className="absolute bottom-16 left-0 right-0 max-w-lg mx-auto bg-bg-light rounded-t-2xl shadow-2xl animate-slide-up">
            <div className="p-4 space-y-2">
              <button
                onClick={() => {
                  // TODO: 跳转到记录页面（暂时用alert提示）
                  setShowMore(false);
                  alert('历史记录功能开发中');
                }}
                className="w-full py-4 px-4 flex items-center gap-4 hover:bg-white/5 rounded-xl text-left"
              >
                <span className="text-2xl">📋</span>
                <div>
                  <p className="font-medium text-text-primary">求助记录</p>
                  <p className="text-sm text-text-muted">查看历史求助和上报</p>
                </div>
              </button>

              <button
                onClick={() => {
                  // TODO: 跳转到设置
                  setShowMore(false);
                  alert('设置页面开发中');
                }}
                className="w-full py-4 px-4 flex items-center gap-4 hover:bg-white/5 rounded-xl text-left"
              >
                <span className="text-2xl">⚙️</span>
                <div>
                  <p className="font-medium text-text-primary">设置</p>
                  <p className="text-sm text-text-muted">应用设置和数据管理</p>
                </div>
              </button>

              <button
                onClick={() => {
                  setShowMore(false);
                  // TODO: 跳转到隐私政策
                  alert('隐私政策页面开发中');
                }}
                className="w-full py-4 px-4 flex items-center gap-4 hover:bg-white/5 rounded-xl text-left"
              >
                <span className="text-2xl">🔒</span>
                <div>
                  <p className="font-medium text-text-primary">隐私政策</p>
                  <p className="text-sm text-text-muted">了解数据如何保护</p>
                </div>
              </button>

              <button
                onClick={() => {
                  setShowMore(false);
                  alert('关于我们页面开发中');
                }}
                className="w-full py-4 px-4 flex items-center gap-4 hover:bg-white/5 rounded-xl text-left"
              >
                <span className="text-2xl">💡</span>
                <div>
                  <p className="font-medium text-text-primary">关于守望者</p>
                  <p className="text-sm text-text-muted">版本 1.1.0</p>
                </div>
              </button>
            </div>

            {/* 公益宣传 */}
            <div className="p-4 border-t border-white/10">
              <div className="bg-gradient-to-r from-sos-red/20 to-warning/20 rounded-xl p-4 text-center">
                <p className="text-gold font-bold mb-1">💛 守望相助，天下无拐</p>
                <p className="text-text-muted text-xs">
                  每一次转发都是希望，每一次关注都是力量
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
